import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEditorH4 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 640 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M616 64.22c-13.25 0-24 10.75-24 24V256h-167.3l30.83-163.3c2.469-13-6.094-25.56-19.12-28.03c-12.98-2.406-25.58 6.125-28.03 19.16l-36.2 191.8c-1.328 7 .5469 14.25 5.094 19.75C381.9 300.8 388.7 304 395.8 304H592v120.2c0 13.25 10.75 24 24 24s24-10.75 24-24v-336C640 74.97 629.3 64.22 616 64.22zM296 64C282.8 64 272 74.75 272 88V224h-224V88C48 74.75 37.25 64 24 64S0 74.75 0 88v336C0 437.3 10.75 448 24 448s24-10.75 24-24V272h224v152C272 437.3 282.8 448 296 448S320 437.3 320 424V88C320 74.75 309.3 64 296 64z",
		fill: "currentColor"
	})
});
export default SvgEditorH4;
